// #region Type
export const ACTION_TYPE = {
  CALL_API_INIT_MAIL_MAGAZINE_DETAIL: 'CALL_API_INIT_MAIL_MAGAZINE_DETAIL',
  INIT_MAIL_MAGAZINE_DETAIL_SUCCESS: 'INIT_MAIL_MAGAZINE_DETAIL_SUCCESS',
  CALL_API_UPDATE_MAIL_MAGAZINE_DETAIL: 'CALL_API_UPDATE_MAIL_MAGAZINE_DETAIL',
  UPDATE_MAIL_MAGAZINE_DETAIL_SUCCESS: 'UPDATE_MAIL_MAGAZINE_DETAIL_SUCCESS',
  CALL_API_SEND_MAIL_MAGAZINE: 'CALL_API_SEND_MAIL_MAGAZINE',
  SEND_MAIL_MAGAZINE_SUCCESS: 'SEND_MAIL_MAGAZINE_SUCCESS',
  CALL_API_CONFIRM_REQUEST: 'CALL_API_CONFIRM_REQUEST',
  CONFIRM_REQUEST_SUCCESS: 'CONFIRM_REQUEST_SUCCESS',
};
// #endregion

// #region Type
export const actCallInitMailMagazineDetail = (id) => ({
  type: ACTION_TYPE.CALL_API_INIT_MAIL_MAGAZINE_DETAIL,
  id,
});

export const actInitMailMagazineDetailSuccess = (data) => ({
  type: ACTION_TYPE.INIT_MAIL_MAGAZINE_DETAIL_SUCCESS,
  data,
});

export const actCallUpdateMailMagazineDetail = (data) => ({
  type: ACTION_TYPE.CALL_API_UPDATE_MAIL_MAGAZINE_DETAIL,
  data,
});

export const actCallUpdateMailMagazineDetailSuccess = (id) => ({
  type: ACTION_TYPE.UPDATE_MAIL_MAGAZINE_DETAIL_SUCCESS,
  id,
});

export const actCallSendMailMagazine = (id) => ({
  type: ACTION_TYPE.CALL_API_SEND_MAIL_MAGAZINE,
  id,
});

export const actCallSendMailMagazineSuccess = () => ({
  type: ACTION_TYPE.SEND_MAIL_MAGAZINE_SUCCESS,
});

export const actCallConfirmRequest = (id) => ({
  type: ACTION_TYPE.CALL_API_CONFIRM_REQUEST,
  id,
});

export const actCallConfirmRequestSuccess = () => ({
  type: ACTION_TYPE.CONFIRM_REQUEST_SUCCESS,
});
// #endregion
